import { render } from "./IdentityMap.vue?vue&type=template&id=141cb17c"
import script from "./IdentityMap.vue?vue&type=script&lang=js"
export * from "./IdentityMap.vue?vue&type=script&lang=js"

import "./IdentityMap.vue?vue&type=style&index=0&id=141cb17c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__